import { pushEvent, type DataLayer } from "@wbly/common";

export const trackPillClick = (url: string) => {
  return pushEvent(
    window?.dataLayer as DataLayer[],
    "range_page",
    "range_pills",
    "nav_pills",
    `Redirected to ${url}`
  );
};
